/** The NutriCart mark: a basket whose handle is a leaf. */
export function LogoMark({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4 10h16l-1.6 8.2a2 2 0 0 1-2 1.6H7.6a2 2 0 0 1-2-1.6L4 10Z" fill="currentColor" />
      <path d="M8 10c0-3.6 2.2-6 6.5-6.5C14.6 7.4 12.4 10 8 10Z" fill="currentColor" opacity=".65" />
      <path d="M9 13.5v3M12 13.5v3M15 13.5v3" stroke="var(--basil)" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
